import React, { useEffect } from 'react'
import { Typography, Button, Grid } from '@mui/material';
import './styles.css'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RegisterSuccessfull = () => {
    const navigate = useNavigate();
    const userData = useSelector(state => state.registerReducer.userVerifyData);

    const onProceed = (e) => {
        e.preventDefault();
        if (userData && userData.token) {
            localStorage.setItem('token', userData.token);
            localStorage.removeItem('registertoken');
            localStorage.removeItem('authtoken');
            navigate('/room/patient');
        }
    }
    const onBack = () => {
        navigate('/')
    }
    // useEffect(() => {
    //     if (userData && userData.token) {
    //         //localStorage.setItem('token', userData.token);
    //         localStorage.removeItem('registertoken');
    //         localStorage.removeItem('authtoken');
    //         navigate('/room/patient');
    //     }
    // }, [userData]);
    return (
        <div style={{ padding: '10%',marginTop:'20%' }}>
            <Typography style={{
                            fontSize: '28px', fontFamily: 'manrope',
                            fontStyle: 'normal',
                            fontWeight: '600',
                            marginBottom: '5%'
                        }}>
                Registered Successfully.
            </Typography>
            <Grid container style={{width:'100%',justifyContent:'space-between'}}>
                <Button style={{color:'#024C9C', width: '40%', borderColor : '#024C9C',borderWidth:1, fontFamily: 'Manrope', marginTop: '20%', borderRadius: '10px',backgroundColor:'white' }} size='large' variant="outlined" onClick={onBack}>
                    Back
            </Button>
            <Button style={{ width: '40%', backgroundColor: '#024C9C', fontFamily: 'Manrope', marginTop: '20%', borderRadius: '10px' }} size='large' variant="contained" onClick={onProceed}>
                    Proceed
            </Button>
            </Grid>
        </div>
    )
}

export default RegisterSuccessfull
